// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1cbFG","title":"Header_title__XbeaW","left":"Header_left__1fykO","clinicName":"Header_clinicName__1nlcn"};